module.exports = __webpack_public_path__ + "static/media/ABNB_Model_IPOIntelligence_b.a8d54dbc.png";